/**
 * Runtime environment variable access
 * Reads from window.__ENV which is populated by the server at runtime
 *
 * This replaces @beam-australia/react-env functionality
 */

declare global {
  interface Window {
    __ENV?: Record<string, string>;
  }
}

/**
 * Get a runtime environment variable
 * @param key - The environment variable key (without REACT_APP_ prefix)
 * @returns The value or undefined if not set
 */
export function env(key: string): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return window.__ENV?.[key];
}
